module.exports = __webpack_public_path__ + "img/non.961dce8f.svg";